module.exports = (_nStr) => {
    var nStr = _nStr;
    var x;
    var x1;
    var x2;
    var rgx;
    nStr = String(nStr);
    x = nStr.split('.');
    x1 = x[0];
    x2 = x.length > 1 ? '.' + x[1] : '';
    rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1,$2');
    }
    return x1 + x2;
}


// WEBPACK FOOTER //
// ./src/filters/addCommas.js